const transferModal = {
  'transfer-modal-transfer': 'Transfer',
  'transfer-modal-select': 'Select',
  'transfer-modal-amount-value': 'What amount do you want to transfer?',
  'transfer-modal-card-select': 'Which account do you want to transfer to?',
  'transfer-modal-check-data': 'Check your transaction details',
  'transfer-modal-confirm': 'Confirm',
  'transfer-modal-of': 'Transfer of',
  'transfer-modal-to': 'to',
  'transfer-modal-success': 'Transferred successfully',
  'transfer-modal-error': 'Failed to transfer',
  'transfer-modal-nocards': 'No accounts were found for transfer',
};

export default transferModal;
